import { combineReducers } from "redux";
import designReducers from "./reducer";
import aiApolloReducers from "./ai_connect/ai_reducer";
import acReducers from "./accountsService/ac_reducer";
import sbReducers from "./subscriptionServices/sb_reducer";
import actReducers from "./activityService/act_reducer";
import pmtReducers from "./paymentService/pmt_reducer";

const rootReducer = combineReducers({
  data: designReducers,
  apldata: aiApolloReducers,
  acntdata: acReducers,
  sbndata: sbReducers,
  activitydata: actReducers,
  paymentdata: pmtReducers,
});

export default rootReducer;
